import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useBrand } from "@/lib/brand";
import { api } from "@/lib/api";

/**
 * PageviewTracker — fires a single aggregate-counter beacon per route
 * change. No cookie, no localStorage, no visitor ID — see
 * crm/public_routes.py::track_pageview for why that makes this exempt
 * from cookie-consent requirements. Rendered once from SiteFooter, same
 * as FloatingContact, so every tenant page gets it for free.
 */
export default function PageviewTracker() {
  const location = useLocation();
  const brand = useBrand();
  const lastPath = useRef(null);

  useEffect(() => {
    const tenantSlug = brand.tenant_slug;
    if (!tenantSlug || tenantSlug === "foundation") return;
    const path = location.pathname;
    if (lastPath.current === path) return;
    lastPath.current = path;
    api.post("/crm/public/analytics/pageview", {
      tenant_slug: tenantSlug,
      path,
      referrer: document.referrer || "",
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, brand.tenant_slug]);

  return null;
}
